import { render, staticRenderFns } from "./UserGroupingSetting.vue?vue&type=template&id=218d922e&"
import script from "./UserGroupingSetting.vue?vue&type=script&lang=ts&"
export * from "./UserGroupingSetting.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupingSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports